<template>
  <div class="row mb-5 mt-5">
    <product-card
      v-for="product in products"
      :key="product.id"
      :product="product"
      @click.native="redirect($event, product)"
    />
    <h5 v-if="products.length === 0" class="is-empty">Žádné výsledky k zobrazení</h5>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  methods: {
    redirect(e, product) {
      if(!$(e.target).is('.btn') && !$(e.target).is('.icon')) {
        window.location.href = '/produkt/' + product.slug
      }
    }
  }
}
</script>
